{
  "AUTOMATION": {
    "HEADER": "Automatizācija",
    "DESCRIPTION": "Automatizācija var aizstāt un racionalizēt esošos procesus, kuriem nepieciešama manuāla piepūle, piemēram, etiķešu pievienošana un sarunu piešķiršana vispiemērotākajam aģentam. Tas ļauj komandai koncentrēties uz savām stiprajām pusēm, vienlaikus samazinot laiku, kas pavadīts ikdienas uzdevumiem.",
    "LEARN_MORE": "Uzzināt vairāk par automatizāciju",
    "COUNT": "{n} automation | {n} automations",
    "HEADER_BTN_TXT": "Create Automation",
    "LOADING": "Notiek automatizācijas noteikumu iegūšana",
    "SEARCH_PLACEHOLDER": "Search automation rules...",
    "NO_RESULTS": "No automation rules found matching your search",
    "ADD": {
      "TITLE": "Pievienot Automatizācijas Noteikumu",
      "SUBMIT": "Izveidot",
      "CANCEL_BUTTON_TEXT": "Atcelt",
      "FORM": {
        "NAME": {
          "LABEL": "Noteikuma Nosaukums",
          "PLACEHOLDER": "Ievadiet noteikuma nosaukumu",
          "ERROR": "Nepieciešams nosaukums"
        },
        "DESC": {
          "LABEL": "Apraksts",
          "PLACEHOLDER": "Ievadiet noteikuma aprakstu",
          "ERROR": "Nepieciešams apraksts"
        },
        "EVENT": {
          "LABEL": "Notikums",
          "PLACEHOLDER": "Lūdzu, izvēlieties vienu",
          "ERROR": "Nepieciešams notikums"
        },
        "CONDITIONS": {
          "LABEL": "Nosacījumi"
        },
        "ACTIONS": {
          "LABEL": "Darbības"
        }
      },
      "CONDITION_BUTTON_LABEL": "Pievienot Nosacījumu",
      "ACTION_BUTTON_LABEL": "Pievienot Darbību",
      "API": {
        "SUCCESS_MESSAGE": "Automatizācijas noteikums ir veiksmīgi pievienots",
        "ERROR_MESSAGE": "Nevarēja izveidot automatizācijas noteikumu. Lūdzu, vēlāk mēģiniet vēlreiz"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Nosaukums",
        "ACTIVE": "Aktīvs",
        "CREATED_ON": "Izveidots",
        "ACTIONS": "Darbības"
      },
      "404": "Automatizācijas noteikumi nav atrasti"
    },
    "DELETE": {
      "TITLE": "Dzēst automatizācijas noteikumu",
      "SUBMIT": "Dzēst",
      "CANCEL_BUTTON_TEXT": "Atcelt",
      "CONFIRM": {
        "TITLE": "Apstiprināt Dzēšanu",
        "MESSAGE": "Vai vēlaties izdzēst ",
        "YES": "Jā, Dzēst ",
        "NO": "Nē, Paturēt "
      },
      "API": {
        "SUCCESS_MESSAGE": "Automatizācijas noteikums ir veiksmīgi izdzēsts",
        "ERROR_MESSAGE": "Nevarēja izdzēst automatizācijas noteikumu. Lūdzu, vēlāk mēģiniet vēlreiz"
      }
    },
    "EDIT": {
      "TITLE": "Rediģēt Automatizācijas Noteikumu",
      "SUBMIT": "Atjaunināt",
      "CANCEL_BUTTON_TEXT": "Atcelt",
      "API": {
        "SUCCESS_MESSAGE": "Automatizācijas noteikums ir veiksmīgi atjaunināts",
        "ERROR_MESSAGE": "Nevarēja atjaunināt automatizācijas noteikumu. Lūdzu, vēlāk mēģiniet vēlreiz"
      }
    },
    "CLONE": {
      "TOOLTIP": "Klonēt",
      "API": {
        "SUCCESS_MESSAGE": "Automatizācija ir veiksmīgi noklonēta",
        "ERROR_MESSAGE": "Nevarēja noklonēt automatizācijas noteikumu. Lūdzu, vēlāk mēģiniet vēlreiz"
      }
    },
    "FORM": {
      "EDIT": "Rediģēt",
      "CREATE": "Izveidot",
      "DELETE": "Dzēst",
      "CANCEL": "Atcelt",
      "RESET_MESSAGE": "Mainot notikuma tipu tiks atiestatīti tālāk pievienotie nosacījumi un notikumi"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "Lai saglabātu, Jums ir nepieciešams vismaz viens nosacījums",
      "CONTACT_CUSTOM_ATTR_LABEL": "Kontaktpersonu Pielāgotās Īpašības",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Sarunu Pielāgotās Īpašības"
    },
    "ACTION": {
      "DELETE_MESSAGE": "Lai saglabātu, ir nepieciešama vismaz viena darbība",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Ievadiet savu ziņojumu šeit",
      "TEAM_DROPDOWN_PLACEHOLDER": "Izvēlieties komandas",
      "EMAIL_INPUT_PLACEHOLDER": "Ievadiet e-pastu",
      "URL_INPUT_PLACEHOLDER": "Ievadiet URL"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Aktivizēt Automatizācijas Noteikumu",
      "DEACTIVATION_TITLE": "Deaktivizēt Automatizācijas Noteikumu",
      "ACTIVATION_DESCRIPTION": "Šī darbība aktivizēs automatizācijas noteikumu '{automationName}'. Vai tiešām vēlaties turpināt?",
      "DEACTIVATION_DESCRIPTION": "Šī darbība deaktivizēs automatizācijas noteikumu '{automationName}'. Vai tiešām vēlaties turpināt?",
      "ACTIVATION_SUCCESFUL": "Automatizācijas Noteikums ir Veiksmīgi Aktivizēts",
      "DEACTIVATION_SUCCESFUL": "Automatizācijas Noteikums ir Veiksmīgi Deaktivizēts",
      "ACTIVATION_ERROR": "Nevarēja Aktivizēt Automatizāciju. Lūdzu, vēlāk mēģiniet vēlreiz",
      "DEACTIVATION_ERROR": "Nevarēja Deaktivizēt Automatizāciju. Lūdzu, vēlāk mēģiniet vēlreiz",
      "CONFIRMATION_LABEL": "Jā",
      "CANCEL_LABEL": "Nē"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Nevarēja augšupielādēt pielikumu. Lūdzu, mēģiniet vēlreiz",
      "LABEL_IDLE": "Augšupielādēt pielikumu",
      "LABEL_UPLOADING": "Notiek augšupielāde...",
      "LABEL_UPLOADED": "Veiksmīgi Augšupielādēts",
      "LABEL_UPLOAD_FAILED": "Augšupielāde neizdevās"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Nepieciešama atribūta atslēga",
      "FILTER_OPERATOR_REQUIRED": "Nepieciešams filtra operators",
      "VALUE_REQUIRED": "Nepieciešama vērtība",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Vērtībai ir jābūt no 1 līdz 998",
      "ACTION_PARAMETERS_REQUIRED": "Nepieciešami darbības parametri",
      "ATLEAST_ONE_CONDITION_REQUIRED": "Ir nepieciešams vismaz viens nosacījums",
      "ATLEAST_ONE_ACTION_REQUIRED": "Ir nepieciešama vismaz viena darbība"
    },
    "NONE_OPTION": "Nav",
    "LAST_RESPONDING_AGENT": "Last Responding Agent",
    "EVENTS": {
      "CONVERSATION_CREATED": "Saruna izveidota",
      "CONVERSATION_UPDATED": "Saruna Atjaunināta",
      "MESSAGE_CREATED": "Ziņojums Izveidots",
      "CONVERSATION_RESOLVED": "Conversation Resolved",
      "CONVERSATION_OPENED": "Saruna Atvērta"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Piešķirt Aģentam",
      "ASSIGN_TEAM": "Piešķirt Komandai",
      "REMOVE_ASSIGNED_AGENT": "Remove Assigned Agent",
      "REMOVE_ASSIGNED_TEAM": "Noņemt Piešķirto Komandu",
      "ADD_LABEL": "Pievienot Etiķeti",
      "REMOVE_LABEL": "Noņemt Etiķeti",
      "SEND_EMAIL_TO_TEAM": "Nosūtīt E-pastu Komandai",
      "SEND_EMAIL_TRANSCRIPT": "Nosūtīt uz E-pastu Transkriptu",
      "MUTE_CONVERSATION": "Izslēgt Sarunu",
      "SNOOZE_CONVERSATION": "Atlikt Sarunu",
      "RESOLVE_CONVERSATION": "Atrisināt Sarunu",
      "SEND_WEBHOOK_EVENT": "Nosūtīt Webhook Notikumu",
      "SEND_ATTACHMENT": "Sūtīt Pielikumu",
      "SEND_MESSAGE": "Nosūtīt Ziņojumu",
      "ADD_PRIVATE_NOTE": "Pievienot Privātu Piezīmi",
      "CHANGE_PRIORITY": "Mainīt prioritāti",
      "ADD_SLA": "Pievienot SLA",
      "OPEN_CONVERSATION": "Atvērt sarunu",
      "PENDING_CONVERSATION": "Mark conversation as pending"
    },
    "MESSAGE_TYPES": {
      "INCOMING": "Incoming Message",
      "OUTGOING": "Outgoing Message"
    },
    "PRIORITY_TYPES": {
      "NONE": "Nav",
      "LOW": "Zema",
      "MEDIUM": "Vidēja",
      "HIGH": "Augsta",
      "URGENT": "Steidzama"
    },
    "ATTRIBUTES": {
      "MESSAGE_TYPE": "Ziņojuma Tips",
      "PRIVATE_NOTE": "Privāta Piezīme",
      "MESSAGE_CONTAINS": "Ziņojums Satur",
      "EMAIL": "E-pasts",
      "INBOX": "Iesūtne",
      "CONVERSATION_LANGUAGE": "Sarunas Valoda",
      "PHONE_NUMBER": "Telefona numurs",
      "STATUS": "Statuss",
      "BROWSER_LANGUAGE": "Pārlūkprogrammas Valoda",
      "MAIL_SUBJECT": "E-pasta Tēma",
      "COUNTRY_NAME": "Valsts",
      "COMPANY_NAME": "Uzņēmums",
      "REFERER_LINK": "Novirzītāja Saite",
      "ASSIGNEE_NAME": "Uzdevuma saņēmējs",
      "TEAM_NAME": "Komanda",
      "PRIORITY": "Prioritāte",
      "LABELS": "Etiķetes"
    }
  }
}
